exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-3164343e] {\n  color: var(--button-color);\n  background-color: var(--button-background-color);\n}\nbutton[data-v-3164343e]:hover {\n  color: var(--button-color);\n  filter: brightness(95%);\n}\nbutton[data-v-3164343e]:active {\n  filter: brightness(90%);\n}", ""]);

// exports
